// Paxos SDK Configuration for campUSD bridging
import { mainnet } from "wagmi/chains";

// Camp Network configuration
export const campNetwork = {
  id: 484,
  name: "Camp Network",
} as const;

// Paxos SDK Configuration
export const PAXOS_CONFIG = {
  // Vault configuration for campUSD
  VAULT_KEY: "campUSD", // Using string format as mentioned in instructions
  VAULT_KEY_ENUM: "CAMPUSD", // VaultKeys.CAMPUSD format

  // Supported networks
  SUPPORTED_CHAINS: {
    SOURCE: mainnet.id, // Ethereum Mainnet
    DESTINATION: campNetwork.id, // Camp Network
  },

  // Token symbols
  TOKENS: {
    ETHEREUM: "USDC", // USDC on Ethereum
    CAMP: "CampUSD", // CampUSD on Camp Network
  },

  // Contract addresses (these will be handled by Paxos SDK)
  CONTRACT_ADDRESSES: {
    ETHEREUM_USDC: "0xA0b86a33E6441e5F60C4fC6e59A29cF0eA4e4e7E",
    CAMP_USD: "0x977fdEF62CE095Ae8750Fd3496730F24F60dea7a",
  },
} as const;

// Paxos-specific bridge states
export type PaxosBridgeState = {
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
  error: Error | null;
  txHash?: string;
  // Paxos-specific states
  isPreparing?: boolean;
  isApproving?: boolean;
  isExecuting?: boolean;
  paxosStep?: "preparing" | "approving" | "executing" | "confirming";
};

export const INITIAL_PAXOS_STATE: PaxosBridgeState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  error: null,
  isPreparing: false,
  isApproving: false,
  isExecuting: false,
};
